import { delay, HttpResponse } from "msw";

export const postAcceptTerms = async () => {
  await delay("real");
  return HttpResponse.text("true");
};
